import { render, staticRenderFns } from "./PerfilCargos.vue?vue&type=template&id=44e89021"
import script from "./PerfilCargos.vue?vue&type=script&lang=ts"
export * from "./PerfilCargos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports